import React, {useEffect, useState} from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const RoleMultiSelect = ({roles, value, onChange}) => {
    const [selected, setSelected] = useState([]);
    useEffect(() => {
        if (!value) return;
        let ids = [];
        if (typeof value.roleListIds === 'string') {
            ids = value.roleListIds.split(', ').map(v => v.trim());
        } else if (Array.isArray(value.roleListIds)) {
            ids = value.roleListIds.map(v => v.toString());
        }
        const selectedRoles = roles.filter(r => ids.includes(r.roleId.toString()))
            .map(r => ({value: r.roleId.toString(), label: r.name}));
        setSelected(selectedRoles);
    }, [value, roles]);

    const handleChange = (e) => {
        setSelected(e);
        const roleNames = e.map(s => s.label);
        const roleIds = e.map(s => s.value.toString());
        onChange({
            roleList: roleNames,
            roleListIds: roleIds
        });
    };
    const animatedComponents = makeAnimated();
    return (
        <Select
            closeMenuOnSelect={true}
            components={animatedComponents}
            isMulti
            options={roles.map((role) => ({value: role.roleId.toString(), label: role.name}))}
            value={selected}
            onChange={handleChange}
            placeholder="Select roles..."
        />
    );
}
export default RoleMultiSelect;